import { FOCUS_RING } from "./tokens";

// 켜고 끄는 값 하나: 체크박스보다 "지금 켜져 있는지"가 한눈에 들어온다.
// 라벨을 눌러도 토글되도록 전체를 label 로 감싸고, 실제 입력은 스크린리더용으로 숨겨 둔다.
// (sr-only + peer 로 두면 키보드 포커스와 접근성 트리를 그대로 유지할 수 있다.)
export default function Toggle({
  checked,
  onChange,
  label,
  helper,
  disabled = false,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  helper?: string;
  disabled?: boolean;
}) {
  return (
    <label
      className={`flex items-start gap-3 ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      }`}
    >
      <span className="relative mt-0.5 inline-flex shrink-0">
        <input
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span
          className={`block h-5 w-9 rounded-full transition-colors ${
            checked ? "bg-[#0F55A7]" : "bg-slate-300"
          } peer-focus-visible:outline-none ${FOCUS_RING}`}
        />
        {/* 손잡이: 켜지면 오른쪽으로 민다 */}
        <span
          className={`pointer-events-none absolute top-0.5 h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${
            checked ? "translate-x-[1.125rem]" : "translate-x-0.5"
          }`}
        />
      </span>
      <span className="flex flex-col gap-0.5">
        <span className="text-sm text-slate-700">{label}</span>
        {helper && <span className="text-xs text-slate-500">{helper}</span>}
      </span>
    </label>
  );
}
